module.exports = __webpack_public_path__ + "static/media/ic_上传圈子.527c5f34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_上传圈子.svg
// module id = 371
// module chunks = 0